import List from 'components/Common/List'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { isEmpty } from 'lib/array/arrayUtils'
import { getInclusionIcon } from 'lib/offer/getInclusionIcon'
import getInclusionMinStayText from 'lib/offer/getInclusionMinStayText'
import React, { Fragment, useMemo } from 'react'
import styled from 'styled-components'
import cn from 'clsx'

const InclusionsList = styled(List)`
  margin-top: 0;

  ${mediaQueryUp.desktop} {
    columns: 2;

    &.singleColumn {
      columns: 1;
    }
  }
`

interface Props {
  tileInclusionsList: App.TileInclusion[];
  heading: string;
}

function OfferPageIntroInclusions(props: Props) {
  const {
    tileInclusionsList,
    heading,
  } = props

  const singleColumn = tileInclusionsList.length < 4

  const inclusions = useMemo(() =>
    tileInclusionsList.map(inclusion => {
      const InclusionIcon = getInclusionIcon(inclusion.icon ?? '')
      const inclusionMinStayText = getInclusionMinStayText(inclusion)
      return (
        <Fragment key={inclusion.text}>
          <BodyTextBlock variant="medium" startIcon={<InclusionIcon />}>
            {inclusion.text} {inclusionMinStayText}
          </BodyTextBlock>
        </Fragment>
      )
    }), [tileInclusionsList])

  if (isEmpty(tileInclusionsList)) {
    return null
  }

  return (<Group gap={12} direction="vertical">
    <BodyText variant="large" weight="bold">{heading}</BodyText>
    <InclusionsList as="div" className={cn({ singleColumn })}>
      {inclusions}
    </InclusionsList>
  </Group>
  ) }

export default OfferPageIntroInclusions
